import axios from 'axios';
import { buildApiUrl } from '../config/api';

export const AsistenciaService = {
    getAsistenciaConsolidad: async ({ token, pagina = 1, pageSize = 20, desde, hasta, documento, nombre }) => {
        try {
            const response = await axios.get(buildApiUrl('/api/asistencias/consolidado'), {
                headers: { Authorization: `Bearer ${token}` },
                params: { pagina, pageSize, desde, hasta, documento, nombre },
            });

            return {
                asistencias: response.data.asistencias || [],
                totalPaginas: response.data.totalPaginas || 1,
                totalRegistros: response.data.totalRegistros || 0,
            };
        } catch (error) {
            console.error('Error en AsistenciaService.getAsistenciaConsolidad:', error);
            throw error;
        }
    },
    getAsistenciaDetallada: async ({ token, pagina = 1, pageSize = 20, desde, hasta, documento, nombre, estado }) => {
        try {
            const response = await axios.get(buildApiUrl('/api/asistencias/detallado'), {
                headers: { Authorization: `Bearer ${token}` },
                params: { pagina, pageSize, desde, hasta, documento, nombre, estado },
            });

            return {
                asistencias: response.data.asistencias || [],
                totalPaginas: response.data.totalPaginas || 1,
                totalRegistros: response.data.totalRegistros || 0,
            };
        } catch (error) {
            console.error('Error en AsistenciaService.getAsistenciaDetallada:', error);
            throw error;
        }
    },
    getAsistenciaMarcacion: async ({ token, pagina = 1, pageSize = 20, desde, hasta, documento, nombre, estado }) => {
        try {
            const response = await axios.get(buildApiUrl('/api/asistencias/marcacion'), {
                headers: { Authorization: `Bearer ${token}` },
                params: { pagina, pageSize, desde, hasta, documento, nombre, estado },
            });

            return {
                asistencias: response.data.asistencias || [],
                totalPaginas: response.data.totalPaginas || 1,
                totalRegistros: response.data.totalRegistros || 0,
            };
        } catch (error) {
            console.error('Error en AsistenciaService.getAsistenciaDetallada:', error);
            throw error;
        }
    },
    getEstadosAsistencia: async (token) => {
        try {
            const response = await axios.get(
                buildApiUrl('/api/ajustes/estadoAsistencia'),
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            return response.data.estados;
        } catch (error) {
            console.error('Error en getEstadosAsistencia:', error);
            throw error;
        }
    },
    exportarConsolidadoExcel: async (token, filtros) => {
        try {
            const response = await axios.post(buildApiUrl('/api/asistencias/exportarConsolidado'), filtros, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob',
            });

            return response.data;
        } catch (error) {
            console.error('Error en AsistenciaService.exportarConsolidadoExcel:', error);
            throw error;
        }
    },
    exportarDetalladaExcel: async (token, filtros) => {
        try {
            const response = await axios.post(buildApiUrl('/api/asistencias/exportarDetallada'), filtros, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob',
            });

            return response.data;
        } catch (error) {
            console.error('Error en AsistenciaService.exportarDetalladaExcel:', error);
            throw error;
        }
    },
    exportarMarcacionExcel: async (token, filtros) => {
        try {
            const response = await axios.post(buildApiUrl('/api/asistencias/exportarMarcacion'), filtros, {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob',
            });

            return response.data;
        } catch (error) {
            console.error('Error en AsistenciaService.exportarMarcacionExcel:', error);
            throw error;
        }
    },
};
